'use client';
import CircularProgress from '@mui/material/CircularProgress';
import Stack from '@mui/material/Stack';

interface SpinnerLoadingProps {
    fullScreen?: boolean;
    size?: number;
}

const SpinnerLoading: React.FC<SpinnerLoadingProps> = ({
    fullScreen = false,
    size = 40,
}) => (
    <Stack
        justifyContent='center'
        alignItems='center'
        sx={{
            height: '100%',
            ...(fullScreen && {
                position: 'fixed',
                top: 0,
                left: 0,
                bgcolor: 'rgba(255,255,255,0.7)',
                width: '100vw',
                zIndex: theme => theme.zIndex.modal + 1,
            }),
        }}
    >
        <CircularProgress size={size} />
    </Stack>
);

export default SpinnerLoading;
